import odata from "@/core/api/mixin/odata";
import { apiClient } from "@/core/api/httpClient";

export default {
  ...odata("scheduler_workers"),
  getById: function (id) {
    return apiClient.get(`scheduler_workers/${id}`, {
      params: {
        relations: "schedulerWorkerLogs",
      },
    });
  },
};
